import { Vue, Component, Watch } from 'vue-property-decorator'
import CustomerList from '@/components/dashboard/customer/customer-list/CustomerList.component.vue'
import CustomerFilter from '@/components/dashboard/customer/customer-filter/CustomerFilter.component.vue'
import { CustomerSummary, TableHeader } from '@/types'
import Axios from 'axios'

@Component({
  components: {
    CustomerList,
    CustomerFilter
  }
})
export default class CustomerPageComponent extends Vue {
  items: CustomerSummary[] = []
  toggleFilter: boolean = false
  totalPage: number = 1
  page: number = 1
  dataFilter: Object = {
    from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
    to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().substr(0, 10)
  }

  loadingData: boolean = false

  itemsTotals = []
  headerTotals: TableHeader[] = [
    {
      text: 'Total General',
      value: 'title',
      sortable: false
    },
    {
      text: 'Gravado',
      value: 'taxedAmount',
      sortable: false
    },
    {
      text: 'Exonerado',
      value: 'exoneratedAmount',
      sortable: false
    },
    {
      text: 'I.G.V.',
      value: 'taxAmount',
      sortable: false
    },
    {
      text: 'Total',
      value: 'totalAmount',
      sortable: false
    }
  ]

  @Watch('page')
  changePage (value:number, oldValue:number) {
    this.loadCustomerSummary()
  }

  mounted () {
    this.loadCustomerSummary()
  }

  loadCustomerSummary () {
    this.loadingData = true
    Axios.get('/documents/summary-customers', {
      params: {
        ...this.dataFilter,
        page: this.page
      }
    }).then(response => {
      this.items = response.data.page.data
      this.totalPage = response.data.page.last_page
      this.itemsTotals = response.data.summary
      this.loadingData = false
    })
  }

  onFilter (data:Object) {
    this.dataFilter = data
    this.loadCustomerSummary()
  }
}
